<!--
* @program: office_automation 
* @author: ly
* @component:FromOtherBank 
* @description: 其他账户转入的情况
* @create: 2022-02-22 10:02
-->
<template>
    <div class="center-flex">
        <span class="statistic-label"> 合计：{{summary}} 元</span>
        <MonthMoneySum :start-date="record.balanceDate" :records="argument.dataSource" date-seg="payDate" sum-seg="payAmount" />
    </div>
    <div style="height:600px">
    <ArScrollTable :scrolls="{y:600}" :argument="argument" :view-model="true" :page-size="pageSize">
        <template #action="{record}">
            <div class="action-column">
                <a-button class="action-button" type="link" @click="showDetail(record)">
                    <SearchOutlined class="pointer"/>
                </a-button>
            </div>
        </template>
    </ArScrollTable>
    </div>
    <a-modal v-model:visible="visible"
             destroyOnClose
             :footer="null"
             :title="null">
        <ArBaseForm :argument="formArg" :view-model="viewModel" >

        </ArBaseForm>
    </a-modal>
</template>

<script>
    import OtherOutflow from "./OtherOutflow";
    import otherPay from "../../../assets/api/otherPay";
    import Column from "../../../assets/tables/parts/column";
    import ColumnType from "../../../assets/tables/parts/column_type";
    export default {
        name: "FromOtherBank",
        mixins:[OtherOutflow],
        methods:{
            init(){
                this.visible = false;
                this.argument.loading = true;
                this.argument.dataSource = [];
                let data = {
                    "approvalState": "1",
                    "receiveBankId": this.record.id,
                };
                otherPay.queryAll.requestPOST(this,data,res=>{
                    this.argument.loading = false;
                    if(res.data.flag){
                        this.argument.dataSource = res.data.data;
                        this.$emit("update:value",{value:this.summary,loading:false});
                    }
                    else{
                        this.$emit("update:value",{value:0,loading:false});
                    }
                })
            },
        },
        created() {
            this.argument.tableColumns = [
                new Column("序号","_index",ColumnType.Index,false).setTableView(60),
                new Column("支付类型","type",ColumnType.Enum).setTableView(150)
                    .setEnum(["1","2","3","4"],["银行账户间转账","由银行卡取出到现金账户","由现金账户存入银行卡","支出"],["cyan","blue","green","red"]),
                new Column("费用类别","categoryId",ColumnType.Category,true),
                new Column("支付金额","payAmount",ColumnType.Number,true).setDefaultValue(0).setTableView(100),
                new Column("支付日期","payDate",ColumnType.Date,true).setTableView(100),
                new Column("支付账户","payBankId",ColumnType.Selector,true).setTableView(150)
                    .setSelectorObject("payBankNum",[]),
                new Column("操作","actions","actions",false).setTableView(80)
            ];
        }

    }
</script>

<style scoped>

</style>